import { useNavigate, useParams } from 'react-router-dom'
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons'
import { Button, Icon, Text, Breadcrumb } from '@/ui'
import { CalcBreakdown } from './CalculationOutputs'
import { useReselector } from '@/utils/sharedHooks'
import { selectTaxCalculationByTaxQuarter } from '@/selectors/userTaxCalculation.selectors'
import { TypographyStyles } from '@/styles'

export const EstimateBreakdownV2 = () => {
  const { taxQuarter } = useParams()
  const navigate = useNavigate()
  const taxCalc = useReselector(selectTaxCalculationByTaxQuarter, taxQuarter)

  if (!taxCalc) {
    return null
  }

  return (
    <div className="flex flex-col space-y-6 p-4">
      <Breadcrumb>
        <Breadcrumb.List>
          <Breadcrumb.Item>
            <Breadcrumb.Link
              onClick={() => navigate('/taxes/quarterly')}
              className="inline-flex items-center text-sm font-medium"
            >
              <Icon icon={faArrowLeft} className="mr-2" />
              Back to Quarterly Taxes
            </Breadcrumb.Link>
          </Breadcrumb.Item>
        </Breadcrumb.List>
      </Breadcrumb>

      {/* Page title */}
      <Text variant={TypographyStyles.H3}>
        How were your quarterly tax estimates calculated?
      </Text>

      <CalcBreakdown calcId={taxCalc.id} />

      <Button
        variant="secondary"
        className="w-full md:w-1/3 lg:w-1/4"
        onClick={() => navigate('/taxes/quarterly')}
      >
        Back to Quarterly Taxes
      </Button>
    </div>
  )
}
